module.exports = __webpack_public_path__ + "img/10551397_L.c8ec6235.png";